define('modules/form_editor/views/base_element_editor',['require','exports','module','base/view','lib/util','ldsh!../templates/element'],function (require, exports, module) {
  'use strict';
  var BaseView = require('base/view'),
    util = require('lib/util');

  module.exports = BaseView.extend({
    template: require('ldsh!../templates/element'),
    events: {
      'change .js-label': 'updateModel',
      'change .js-hidelabel': 'updateModel',
      'change .js-required': 'updateModel',
      'change .js-field-width': 'updateModel',
      'change .js-element-id': 'updateModel',
    },
    helpers: function () {
      var helpers = {
        isLabelHidden: this.model.get('labelVisible') ? '' : 'checked',
        labelText: this.model.get('labelText') ? this.model.get('labelText') : '',
        elementId: this.getElementId(),
        isRequired: this.model.get('isRequired') ? 'checked' : '',
        isRequiredReadOnly: this.model.get('isRequiredReadOnly') ? 'readonly' : '',
        isNewline: this.model.get('isNewline') ? 'checked' : '',
        fieldWidth: this.model.get('fieldWidth'),
        isCustomDate: this.isCustomDate(),
        isHiddenField: this.model.get('name') === 'input:hidden',
        isTermsElement: this.model.get('name') === 'custom:terms',
      };

      return helpers;
    },

    isCustomDate: function () {
      return (
        this.model.get('name') === 'custom:date' || this.model.get('name') === 'custom:date_amp'
      );
    },

    getElementId: function () {
      return this.model.get('elementId') ? this.model.get('elementId') : this.generateElementId();
    },

    generateElementId: function () {
      return 'ID' + util.generateRandom();
    },
    validateElementId: function () {
      var value = this.$('.js-element-id').val();
      value = value ? value.trim() : '';
      if (value == '') {
        this.showErrors('id', 'required');
        this.$('.js-element-id').val(this.model.get('elementId'));
        return false;
      }

      if (this.model.areThereOtherItemWithThisAtributteName(value, 'elementId')) {
        this.showErrors('id', 'unique');
        this.$('.js-element-id').val(this.model.get('elementId'));
        return false;
      }
      this.model.set('elementId', value);
      return true;
    },
    validateLabelText: function () {
      var labelValue = this.$('.js-label').val();
      var labelText = labelValue ? labelValue.trim() : '';
      if (labelText !== '') {
        this.model.set('labelText', labelText);
        return true;
      }
      this.showErrors('label', 'required');
      this.$('.js-label').val(this.model.get('labelText'));
      return false;
    },
    validate: function () {
      this.hideErrors();
      if (!this.validateElementId()) {
        return false;
      }
      if (!this.validateLabelText()) {
        return false;
      }
      return true;
    },
    hideErrors: function () {
      this.$('.ed-help-block').parent().removeClass('has-error');
      this.$('.js-error').addClass('hidden');
      this.$('.ed-help-block').addClass('hidden');
    },
    showErrors: function (field, error) {
      this.$('.js-label-group-' + field).addClass('has-error');
      this.$('.ed-help-block.js-error-' + field + '-' + error).removeClass('hidden');
    },
    updateModel: function () {
      this.unbindModel();
      if (this.validate()) {
        this.model.set('labelVisible', !this.$('.js-hidelabel').is(':checked'));
        this.model.set('isRequired', this.$('.js-required').is(':checked') || false);
        this.model.set('widthClass', this.$('.js-field-width').val());
        //just one change -> just one re-render
        this.model.trigger('change');
      }
      this.bindModel();
    },

    unbindModel: function () {
      this.stopListening(this.model, 'change');
    },

    bindModel: function () {
      this.listenTo(this.model, 'change', this.render);
    },

    onRender: function () {
      this.$el.i18n();
      this.$('.js-field-width').val(this.model.get('widthClass'));
    },
  });
});

